import { render, staticRenderFns } from "./PlanoDeCarreira.vue?vue&type=template&id=1a075e27"
import script from "./PlanoDeCarreira.vue?vue&type=script&lang=js"
export * from "./PlanoDeCarreira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports